import React from 'react';

interface FormRadioItemProps extends React.HTMLProps<HTMLLabelElement & HTMLInputElement> {
  combineLabel?: Boolean;
  darkMode?: Boolean;
  inputAddOn?: String;
  errorMessage?: String;
  disabledMessage?: String;
  description?: string;
  backgroundClassName?: string;
  onChange?: (event: React.ChangeEvent<HTMLLabelElement & HTMLInputElement>) => void;
}

type Props = React.FC<FormRadioItemProps>;

const FormRadioItem: Props = ({ placeholder = 'Enter something...', backgroundClassName = 'bg-white', ...props }) => {
  var { combineLabel, label, inputAddOn, errorMessage, disabledMessage, darkMode, className, ...cleanedProps } = props;

  return (
    <label
      {...props}
      className={`
        group
        relative
        z-0
        mx-8
        grid
        items-center
        gap-16
        p-8
        ${className ? className : ''}
      `}
      style={{ gridTemplateColumns: 'auto 1fr' }}
    >
      <input
        type="radio"
        {...cleanedProps}
        className="
          peer
          absolute
          col-start-1
          row-start-1
          m-0
          h-0
          w-0
          border-0
          p-0
          opacity-0
        "
      />
      <span
        className="
          pointer-events-none 
          relative
          z-10
          col-start-1
          row-start-1
          flex
          h-16
          w-16
          items-center
          justify-center
          place-self-center
          rounded-full
          border-1
          border-gray-dark
          bg-gray-lighter
          group-hover:bg-blue-lighter 
          peer-checked:border-blue-dark
          peer-disabled:bg-transparent
        "
      />
      <span
        className="
            z-20
            col-start-1
            row-start-1
            block
            h-8
            w-8
            place-self-center
            rounded-full
            bg-blue-dark
            opacity-0
            peer-checked:opacity-100
          "
      />
      <div
        className="
          pointer-events-none
          z-10
          peer-checked:text-blue-dark
          peer-disabled:cursor-not-allowed
          peer-disabled:text-gray-dark
        "
      >
        <span className="relative block leading-none">{props.label}</span>
        {props.description && <span className="block text-sm">{props.description}</span>}
      </div>
      <span
        className={`
            ${backgroundClassName}
            pointer-events-auto
            absolute
            inset-0
            z-0
            cursor-pointer
            border-1
            border-transparent
            transition
            group-hover:border-blue-dark
            group-hover:bg-blue-lighter
            peer-focus:border-blue
            peer-focus:shadow-form-focus
            peer-disabled:cursor-not-allowed
            peer-disabled:border-transparent
            peer-disabled:bg-gray-lighter
          `}
      />
    </label>
  );
};

export default FormRadioItem;
